export default __webpack_public_path__ + "static/media/jucostareis.96650f0b.jpg";